import React, {useState, useEffect} from 'react'
import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {useLayout} from '../../core'
import {KTIcon} from '../../../helpers'
import {Footer} from './Footer'
import {Link, useLocation} from 'react-router-dom'

const FooterWrapper = () => {
  const intl = useIntl()
  const {config} = useLayout()
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false)
  const location = useLocation()

  const menuItems = [
    {path: '/dashboard', icon: 'abstract-30', labelKey: 'FOOTER.MENU.DASHBOARD'},
    {path: '/search', icon: 'basket', labelKey: 'FOOTER.MENU.MARKET'},
    {path: '/NewShop', icon: 'abstract-10', labelKey: 'FOOTER.MENU.SHOP'},
    {path: '/map', icon: 'geolocation', labelKey: 'FOOTER.MENU.MAP'},
    {path: '/setting', icon: 'setting-2', labelKey: 'FOOTER.MENU.SETTINGS'},
  ]

  useEffect(() => {
    // بررسی اندازه صفحه
    const handleResize = () => {
      setIsMobileOrTablet(window.innerWidth <= 1024) // موبایل و تبلت
    }

    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  if (!config.app?.footer?.display) {
    return null
  }

  return (
    <div className='app-footer w-100' id='kt_app_footer'>
      <Footer />
      {/* {isMobileOrTablet && (
        <div className="footer-container">
          <div className="bar">
            {menuItems.map((item, index) => (
              <Link
                key={index}
                to={item.path}
                className={clsx('bar-item text-center', {
                  active: location.pathname === item.path,
                })}
              >
                <div className="bar-fluid"></div>
                <div className="drop"></div>
                <KTIcon
                  iconName={`${item.icon}`}
                  className=''
                />
                <span className="bar-label">{intl.formatMessage({id: item.labelKey})}</span>
              </Link>
            ))}
          </div>
        </div>
      )} */}
    </div>
  )
}

export {FooterWrapper}
